// @owners { team: patients }
import { SIZES } from '@alto/design-library-tokens';
import { SizedImage } from '@alto/design-system';
import React from 'react';

export const AppleStoreImage = () => {
  return (
    <SizedImage
      // eslint-disable-next-line @typescript-eslint/no-require-imports
      source={require('./apple_store@2x.png')}
      pixelSize={SIZES.ILLUSTRATION.XL.value}
      maxHeight={SIZES.ILLUSTRATION.SM.value}
      accessibilityLabel="Download Alto iOS app"
    />
  );
};
